var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/rupee.f90ef374.png","uri@2x": __webpack_public_path__ + "static/media/rupee.f18ba186.png","uri@3x": __webpack_public_path__ + "static/media/rupee.98e6f683.png",
    width: 7,
    height: 10
});